import { put, post, remove, get } from './http';

const COMPARE_PRODUCT_API_URL = '/api/compareProduct';

export const addProduct = async (ProductNumber) =>
  await post(COMPARE_PRODUCT_API_URL, {
    ProductNumber,
  });

export const removeProduct = async (ProductNumber) =>
  await remove(COMPARE_PRODUCT_API_URL, {
    ProductNumber,
  });

export const clearProductList = async () =>
  await put(COMPARE_PRODUCT_API_URL + '/all');

export const getProductList = async () => {
  const response = await get(COMPARE_PRODUCT_API_URL + '/getProductList');
  return response.json();
};
